import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 1H1v7.04c0 1.806.962 3.474 2.526 4.377L8 15l4.474-2.583A5.06 5.06 0 0 0 15 8.04zM4.84 4.708v-.002l-.001.002zm0 0v2.187c.301-.339.844-.567 1.467-.567h.676v2.546c0 .678-.184 1.27-.457 1.597h2.942c-.271-.327-.455-.92-.455-1.595V6.33h.676c.622 0 1.168.228 1.466.567V4.708z"
            fill="currentColor"
        />
    </svg>
));
TinkoffSolidSize16Glyph.displayName = 'TinkoffSolidSize16Glyph';
